var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSyncActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#123258",
    fillRule: "evenodd",
    d: "M10.714 5.572A2.57 2.57 0 0 1 13.285 3h5.143a2.572 2.572 0 1 1 0 5.143h-5.143l-1.513 1.513a2.572 2.572 0 0 1-.006 4.692l1.037 1.555a2.6 2.6 0 0 1 .482-.045h5.143a2.572 2.572 0 1 1 0 5.143h-5.143a2.572 2.572 0 0 1-1.426-4.711l-1.145-1.718H5.572a2.572 2.572 0 1 1 0-5.143h5.013l1.554-1.555a2.57 2.57 0 0 1-1.425-2.302",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4CEFF",
    d: "M18.428 4h-5.143a1.572 1.572 0 1 0 0 3.143h5.143a1.572 1.572 0 1 0 0-3.143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDF3C2",
    d: "M10.715 10.429H5.572a1.572 1.572 0 1 0 0 3.143h5.143a1.572 1.572 0 1 0 0-3.143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#97C9FF",
    d: "M18.428 16.858h-5.143a1.572 1.572 0 1 0 0 3.143h5.143a1.572 1.572 0 0 0 0-3.143"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSyncActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sync-active.66481c16.svg";